export const routineCsvHeaders = [
  { label: 'Id', key: 'id' },
  { label: 'Date', key: 'date' },
  { label: 'Name', key: 'name' },
  { label: 'Workout Id', key: 'workout_id' },
  { label: 'Part', key: 'part' },
  { label: 'Condition Id', key: 'condition_id' },
  { label: 'Condition Name', key: 'condition_name' },
  { label: 'Condition Part', key: 'condition_part' },
  { label: 'Condition Workout Id', key: 'condition_workout_id' },
  { label: 'Count', key: 'count' },
  { label: 'Count Placeholder', key: 'count_placeholder' },
  { label: 'RIR', key: 'rir' },
  { label: 'Weight Multiplier', key: 'weight_multiplier' },
  { label: 'Weight Placeholder', key: 'weight_placeholder' },
  { label: 'Set Count', key: 'set_count' },
  { label: 'Alt Workouts', key: 'alt_workouts' },
  { label: 'Alt Workout part', key: 'alt_workouts_part' },
  { label: 'Tip', key: 'tip' },
  { label: 'Rest', key: 'rest_time_sec' },
  { label: 'ChallengeId', key: 'challenge_id' },
];
